
import { enhanceStageCardsInDocument } from './card-enhancer';
import { fixAvatarImagesInDocument } from './avatar-enhancer';
import { enhanceTextElementsInDocument } from './text-enhancer';
import { enforceLightThemeInDocument } from './theme-enforcer';

/**
 * Hides all "Add Stage" buttons in the exported document
 */
export const hideAddStageButtonsInDocument = (clonedDoc: Document): void => {
  // Hide the fixed bottom Add Stage button 
  const bottomAddButton = clonedDoc.querySelector('.glassmorphism.fixed.bottom-6');
  if (bottomAddButton instanceof HTMLElement) {
    bottomAddButton.style.display = 'none';
  }
  
  // Hide the inline Add Stage button in the journey content
  const inlineAddButtons = clonedDoc.querySelectorAll('.flex.items-start.justify-center button');
  inlineAddButtons.forEach(button => {
    if (button instanceof HTMLElement && button.querySelector('.h-5.w-5')) {
      const parentContainer = button.closest('.flex.items-start.justify-center');
      if (parentContainer instanceof HTMLElement) {
        parentContainer.style.display = 'none';
      }
    }
  });
};

/**
 * Enhances emotion faces in the document to be more prominent
 */
export const enhanceEmotionFacesInDocument = (clonedDoc: Document): void => {
  // Target all emotion faces
  const emotionFaces = clonedDoc.querySelectorAll('.w-12.h-12.rounded-full');
  emotionFaces.forEach(face => {
    if (face instanceof HTMLElement) {
      // Ensure face is in front of everything
      face.style.zIndex = '50';
      face.style.position = 'relative';
      face.style.transform = 'translateZ(0) scale(1.1)';
      face.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
      
      // Ensure the emoji is centered
      face.style.display = 'flex';
      face.style.alignItems = 'center';
      face.style.justifyContent = 'center';
      
      // Make the emoji more vivid
      face.style.filter = 'contrast(1.1) saturate(1.2)';
    }
  });
  
  // Lower z-index of the curve so faces appear on top
  const journeyConnections = clonedDoc.querySelectorAll('.journey-connection');
  journeyConnections.forEach(connection => {
    if (connection instanceof SVGElement) {
      connection.style.zIndex = '5';
    }
  });
};

/**
 * Master function that applies all document enhancements
 */
export const enhanceClonedDocument = (clonedDoc: Document): void => {
  // Always enforce light theme first (this should happen before other enhancements)
  enforceLightThemeInDocument(clonedDoc);
  
  // Apply remaining enhancements
  enhanceStageCardsInDocument(clonedDoc);
  fixAvatarImagesInDocument(clonedDoc);
  enhanceTextElementsInDocument(clonedDoc);
  
  // Hide "Add Stage" buttons in export
  hideAddStageButtonsInDocument(clonedDoc);
  
  // Enhance emotion faces to be more prominent
  enhanceEmotionFacesInDocument(clonedDoc);
};

// Export individual enhancers for specific use cases
export {
  enhanceStageCardsInDocument,
  fixAvatarImagesInDocument,
  enhanceTextElementsInDocument,
  enforceLightThemeInDocument
};
